import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import {
    AdditionalIncomeTaxation,
    BenefitTaxationComponent,
    Components,
    OtherRemittancesPayComponent,
} from '@payroll/components';
import { Guards } from '@payroll/guards';
import { PayrollResolver } from '@payroll/payroll.resolver';
/* Common Modules */
import { PayrollRouterModule } from '@payroll/payroll.routes';
import { Resolvers } from '@payroll/resolvers';
import { Views } from '@payroll/views';
import { FrameView } from '@payroll/views/frame/frame.view';
/* Module Views */
import { ChildTabBarComponent } from '@app/components/child-tab-bar/child-tab-bar.component';
import { ChildTabComponent } from '@app/components/child-tab-bar/child-tab/child-tab.component';

import { AddAmendedTaxForm } from '../forms/payroll/components/add-amended-tax/add-amended-tax.form';
import { OtherRemittancesDetailsComponent } from '../forms/payroll/components/other-remittances-details/other-remittances-details.component';
import { PaystubViewDetailsComponent } from '../forms/payroll/components/paystub-view-details/paystub-view-details.component';
import { PayrollFormsModule } from '../forms/payroll/payroll-forms.module';
import { TableModule } from '../table/table.module';
import { KYBInquiriesTable } from './components/kyc-kyb/kyb-inquiries/kyb-inquiries.component';
import { KYCKYBStatus } from './components/kyc-kyb/kyc-kyb-status/kyc-kyb-status.component';
import { TaxReturnFormsTables } from './components/tax-returns//tax-return-forms-tables/tax-return-forms-tables.component';
import { EmployeeTaxFormBoxesComponent } from './components/tax-returns/employee-tax-forms/employee-tax-form-boxes/employee-tax-form-boxes.component';
import { EmployeeTaxFormDetailsComponent } from './components/tax-returns/employee-tax-forms/employee-tax-form-details/employee-tax-form-details.component';
import { EmployeeT4NotificationsComponent } from './components/tax-returns/employee-tax-forms/t4-notifications/t4-notifications.component';
import { T4DentalBenefitReminderDialog } from './components/tax-returns/t4-dental-benefit-reminder-dialog/t4-dental-benefit-reminder-dialog.component';
import { TaxFormConsentDialog } from './components/tax-returns/tax-form-consent-dialog/tax-form-consent-dialog.component';
import { RL1SummaryDetailsComponent } from './components/tax-returns/tax-return-summary-details/rl1-summary-details.component';
import { T4SummaryDetailsComponent } from './components/tax-returns/tax-return-summary-details/t4-summary-details.component';
import { Services } from './services';
import { DentalBenefitAssignView } from './views/dental-benefit/dental-benefit-assign/dental-benefit-assign.view';
import { DentalBenefitIndexView } from './views/dental-benefit/dental-benefit-index.view';
@NgModule({
    imports: [
        PayrollRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
        PayrollFormsModule,
        MatProgressSpinnerModule,
        OtherRemittancesDetailsComponent,
        OtherRemittancesPayComponent,
        PaystubViewDetailsComponent,
        KYCKYBStatus,
        DentalBenefitIndexView,
        AddAmendedTaxForm,
        DentalBenefitAssignView,
        T4DentalBenefitReminderDialog,
        ChildTabBarComponent,
        ChildTabComponent,
        T4SummaryDetailsComponent,
        RL1SummaryDetailsComponent,
        TaxReturnFormsTables,
        EmployeeTaxFormDetailsComponent,
        EmployeeTaxFormBoxesComponent,
        KYBInquiriesTable,
        EmployeeT4NotificationsComponent,
        TaxFormConsentDialog,
    ],
    providers: [PayrollResolver, ...Resolvers, ...Services, ...Guards],
    declarations: [FrameView, ...Views, ...Components],
    exports: [AdditionalIncomeTaxation, BenefitTaxationComponent],
})
export class PayrollModule {}
